import { connect } from 'react-redux';
import DuplicateModal from '../duplicate/DuplicateModal';
import { duplicateOtherRenewableEnergy } from '../../redux/renewable_energy/other_renewable_energy_actions';

const mapStateToProps = state => ({
  isDuplicating: state.renewableEnergy.otherEnergy.isDuplicating,
  errorMessage: state.renewableEnergy.otherEnergy.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateOtherRenewableEnergy(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/renewable_energy/OtherRenewableEnergyDuplicateModal.js